import { Skeleton, SkeletonProps } from "@mui/material";

export default (props: SkeletonProps) => (
  <Skeleton
    {...props}
    style={{ ...props.style, backgroundColor: "rgba(0, 0, 0, 0.11)" }}
  />
);
